import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import gif404 from '@/assets/404.gif';

const SYMBOLS = [
  {
    id: 0,
    char: '?',
    left: '5%',
    size: 28,
    duration: 18,
    delay: 0,
    opacity: 0.55,
    rotate: 180,
    color: '#111111',
  },
  {
    id: 1,
    char: '404',
    left: '12%',
    size: 14,
    duration: 22,
    delay: 3,
    opacity: 0.5,
    rotate: -120,
    color: '#333333',
  },
  {
    id: 2,
    char: '/',
    left: '22%',
    size: 36,
    duration: 20,
    delay: 1.5,
    opacity: 0.52,
    rotate: 90,
    color: '#111111',
  },
  {
    id: 3,
    char: '?',
    left: '33%',
    size: 18,
    duration: 24,
    delay: 6,
    opacity: 0.48,
    rotate: -90,
    color: '#222222',
  },
  {
    id: 4,
    char: '4',
    left: '45%',
    size: 42,
    duration: 17,
    delay: 0.5,
    opacity: 0.55,
    rotate: 150,
    color: '#111111',
  },
  {
    id: 5,
    char: '0',
    left: '55%',
    size: 24,
    duration: 26,
    delay: 4,
    opacity: 0.5,
    rotate: -60,
    color: '#333333',
  },
  {
    id: 6,
    char: '/',
    left: '65%',
    size: 16,
    duration: 21,
    delay: 2,
    opacity: 0.53,
    rotate: 120,
    color: '#222222',
  },
  {
    id: 7,
    char: '?',
    left: '74%',
    size: 32,
    duration: 19,
    delay: 8,
    opacity: 0.48,
    rotate: -150,
    color: '#111111',
  },
  {
    id: 8,
    char: '404',
    left: '83%',
    size: 12,
    duration: 28,
    delay: 1,
    opacity: 0.5,
    rotate: 60,
    color: '#333333',
  },
  {
    id: 9,
    char: '4',
    left: '91%',
    size: 22,
    duration: 20,
    delay: 5,
    opacity: 0.52,
    rotate: -180,
    color: '#111111',
  },
  {
    id: 10,
    char: '0',
    left: '18%',
    size: 40,
    duration: 23,
    delay: 10,
    opacity: 0.48,
    rotate: 90,
    color: '#222222',
  },
  {
    id: 11,
    char: '/',
    left: '78%',
    size: 30,
    duration: 18,
    delay: 3.5,
    opacity: 0.5,
    rotate: -90,
    color: '#111111',
  },
];

function FallingSymbols() {
  return (
    <div className='absolute inset-0 overflow-hidden pointer-events-none' aria-hidden='true'>
      {SYMBOLS.map((symbol) => (
        <motion.span
          key={symbol.id}
          className='absolute top-0 select-none font-bold'
          style={{ left: symbol.left, fontSize: symbol.size, opacity: 0, color: symbol.color }}
          animate={{
            y: ['0vh', '110vh'],
            opacity: [0, symbol.opacity, symbol.opacity, 0],
            rotate: [0, symbol.rotate],
          }}
          transition={{
            duration: symbol.duration,
            delay: symbol.delay,
            repeat: Infinity,
            ease: 'linear',
            times: [0, 0.1, 0.9, 1],
          }}
        >
          {symbol.char}
        </motion.span>
      ))}
    </div>
  );
}

export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <section className='bg-white min-h-screen flex items-center justify-center relative overflow-hidden'>
      <FallingSymbols />

      <div className='container mx-auto relative z-10'>
        <div className='flex justify-center'>
          <div className='w-full sm:w-10/12 md:w-8/12 text-center'>
            <div className='relative h-[250px] sm:h-[350px] md:h-[400px]'>
              <img src={gif404} alt='404' className='w-full h-full object-contain' />
              <h1
                className='absolute left-0 right-0 text-center text-black text-6xl sm:text-7xl md:text-8xl z-10'
                style={{ fontFamily: '"Dela Gothic One", sans-serif', top: '5%' }}
              >
                404
              </h1>
              <div className='absolute left-0 right-0 z-10 text-center' style={{ bottom: '-10%' }}>
                <h3 className='text-2xl text-black sm:text-3xl font-bold mb-2 tracking-wider'>
                  Страница не найдена
                </h3>
                <p className='mb-4 text-black text-sm'>Страница, которую вы ищете, недоступна</p>
                <Button
                  variant='default'
                  onClick={() => navigate('/clients')}
                  className='cursor-pointer'
                >
                  На главную
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
